<template>
  <AllRecordsTable
    submit-button-text="Добавить календарь смен"
    table-name="shifts_calendars"
    link-slug="shifts_calendars"
    title="Календари смен"
    :columns="table.columnNames"
    :rows="table.rowNames"
    :filter-fields="table.filterFields"
    :order-fields="orderFields"
  />
</template>

<script>
import AllRecordsTable from "@/_shared/widgets/AllRecordsTable";
import { lists } from "@/user/constants";
import { arrayHelper } from '@/_shared/utils';
export default {
  components: {
    AllRecordsTable,
  },
  computed: {
    orderFields() {
      const { columnNames, rowNames } = this.table;
      return arrayHelper.combine(columnNames, rowNames);
    },
    table() {
      return lists.shiftsCalendars;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/user/pages/AllShiftsCalendarsPage.vue